export default {
    title: "Leveringsbevestiging",
    header: "@:views.survey.delivery.title",
    result: {
        header: "Bedankt",
        message: "Dank u voor uw reactie."
    },
    status: {
        yes: "Controleer de onderstaande aangevinkte producten om de levering te bevestigen en vink de producten die u niet heeft ontvangen uit. Klik vervolgens op Verzenden om te bevestigen.",
        no: "Controleer of u geen van de onderstaande producten heeft ontvangen. Als u wel een van deze producten heeft ontvangen, vink dan het vakje naast ontvangen product(en) aan en klik op Verzenden om te bevestigen."
    },
    model: {
        checked: {
            label: "Ontvangen"
        }
    },
    button: {
        submit: {
            cta: "Indienen",
            processing: "Indienen"
        }
    }
}